import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Apartment icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Apartment } from '@sravni/design-system-icons'
 *
 * <Apartment />
 * ```
 */
var Apartment = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Apartment", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m2.736 7.6 5.5-5.6 5.5 5.6V18h-11V7.6Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M8.736 18h10V7.6L13.111 2l-2.375 2M6.736 9h3M6.736 12h3M6.736 15h3", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Apartment };
//# sourceMappingURL=Apartment.js.map
